import { Button, Icon, Tooltip } from '@sr/ui-library';
import { twMerge } from 'tailwind-merge';

export interface IInputLabelProps {
  className?: string;
  disabled?: boolean;
  inputId: string;
  isLegend?: boolean;
  isRequired?: boolean;
  label: string;
  tooltipText?: string;
}
export const InputLabel = ({
  className,
  inputId,
  isLegend = false,
  isRequired,
  label,
  tooltipText,
}: IInputLabelProps) => {
  const ElementTag = isLegend ? 'legend' : 'label';

  return (
    <ElementTag
      className={twMerge(
        // Dims inside a disabled `<fieldset>` at the same `opacity-50` as the
        // inputs it labels, matching ui-library's `Label` — without it the v2
        // locked entity grid renders 100% labels beside 50% fields.
        'label inline py-1 text-base font-semibold leading-normal text-sr-black [fieldset:disabled_&]:opacity-50',
        className,
      )}
      htmlFor={inputId || undefined}
    >
      {label}
      {isRequired && (
        <>
          *<span className="sr-only">(required)</span>
        </>
      )}
      {tooltipText && (
        <Tooltip
          className="max-w-80"
          content={tooltipText}
          style={{ zIndex: 1000 }}
        >
          <Button
            className="!h-auto"
            icon={<Icon icon="info" weight="fill" />}
            size="icon"
            variant="transparent"
          />
        </Tooltip>
      )}
    </ElementTag>
  );
};
